/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/biblioteca";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/biblioteca/biblioteca",
            controller: 'BibliotecaAdminController',
            controllerForm: 'BibliotecaFormAdminController',
            translateBase: "admin.biblioteca."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                letras: function (Biblioteca) {
                    return Biblioteca.findUsedLetters().$promise.then(function (data) {
                        return data;
                    });
                }
            },
            url: '/listar/:letra/:page',
            params: {
                page: '1',
                letra: 'TODO'
            }

        });


        // Crear
        angular.merge(state.create, {
            resolve: {
                /* @ngInject */
                itemData: function (Biblioteca) {
                    return new Biblioteca();
                }

            }
        });
        // Editar
        angular.merge(state.edit, {
            resolve: {
                /* @ngInject */
                itemData: function (Biblioteca, $stateParams) {
                    return Biblioteca.get({id: $stateParams.id}).$promise;
                }
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
